
<template>
<div>
    <div class="label">
        <span>{{ $t('schedule.fields.day') }}</span>
        {{ formatDate( object.Start) }}
        <span>{{ $t('schedule.fields.start') }}</span>
        {{ formatTime(object.Start) }}
        <span>{{ $t('schedule.fields.end') }}</span>
        {{ formatTime(object.End) }}
        <ul>
            <li v-for="x in object.RShiftUsers" :key="x.User.id">
                <router-link :to="'/user/'+x.User.id">{{ x.User.FullName }}</router-link>
            </li>
        </ul>
    </div>
</div>
</template>
<script>
import Datetime from "@/common/mixins/datetime";

export default {
    mixins:[Datetime],
    name: "ShiftSimpleVisualization",
    props: {
        object: {}
    }
}
</script>


<style scoped lang="scss">

</style>
